import React from 'react'
import { Link } from "react-router-dom";

export default function HomeBrand() {
  return (
    <>
    <section className="banner-section">
        <div className="homebanner-text wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
            <h2 className='heading'>The Brand</h2>
            <p>Elegance Shaped From Your Story</p>
            <Link to={"/about"} className="default-btn">know Now</Link>
        </div>

        <img src="/image/brand-banner.webp" className="img-responsive" alt="brand" loading="lazy"/>
        <div className="banner-overlay"></div>
    </section> 
    </>
  )
}
